import { render, staticRenderFns } from "./duihuan_list.vue?vue&type=template&id=d22fdada&scoped=true"
import script from "./duihuan_list.vue?vue&type=script&lang=js"
export * from "./duihuan_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22fdada",
  null
  
)

export default component.exports